import { render } from "./PartnerList.vue?vue&type=template&id=43d878d2"
import script from "./PartnerList.vue?vue&type=script&lang=js"
export * from "./PartnerList.vue?vue&type=script&lang=js"

import "./PartnerList.vue?vue&type=style&index=0&id=43d878d2&lang=scss"
script.render = render

export default script